export default __webpack_public_path__ + "6b856c42094b7e6fd28e717940687238.png";